"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _reactBootstrap = require("react-bootstrap");

var _reactRouter = require("react-router");

var _reactIntl = require("react-intl");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRedux = require("react-redux");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _mapToState = require("../../mapToState");

var _API = require("../../API");

var _actions = require("../../reducers/reportDetail/actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _ReportDetailAddEditTypeModal = require("./ReportDetailAddEditTypeModal");

var _ReportDetailAddEditTypeModal2 = _interopRequireDefault(_ReportDetailAddEditTypeModal);

var _ReportDetailUploadAttachmentModal = require("./ReportDetailUploadAttachmentModal");

var _ReportDetailUploadAttachmentModal2 = _interopRequireDefault(_ReportDetailUploadAttachmentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailTypeInstance.less");
var momentDateFormatterString = "DD.MM.YYYY HH:mm:ss";
var ReportDetailTypeInstance = function (_React$Component) {
    _inherits(ReportDetailTypeInstance, _React$Component);

    function ReportDetailTypeInstance(props) {
        _classCallCheck(this, ReportDetailTypeInstance);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailTypeInstance).call(this, props));

        _this.onImageUploadSuccess = function (attachmentUid) {
            if (_this.props.currentReportData.dataKey === "issues") {
                _this.props.dispatch(reportDetailActions.saveSelectedReport());
                var instanceData = (0, _lodash.find)(_this.props.currentReportData.dataEntries, { uid: _this.props.instanceUid });
                _this.props.dispatch(reportDetailActions.saveSelectedReport());
            }
        };
        _this.onImageDelete = function (attachmentUid) {
            var target = _API.API.deleteAttachment(_this.props.reportDetail.selectedReport.uid, attachmentUid);
            (0, _mapToState.mapToState)(function () {
                return _this;
            }, function () {
                return _API.client.requestJSON(target);
            }).then(function (value) {
                return _this.props.dispatch(reportDetailActions.saveSelectedReport());
            });
        };
        _this.state = {
            showModal: null,
            isLoading: false
        };
        return _this;
    }

    _createClass(ReportDetailTypeInstance, [{
        key: "getFormattedValueForType",
        value: function getFormattedValueForType(type, data) {
            if (type === "value") {
                return data.value;
            } else if (type === "date") {
                // fixed date format!
                return (0, _moment2.default)(data.value).format(momentDateFormatterString);
            } else if (type === "text") {
                return data.value;
            } else if (type === "num") {
                return data.value;
            } else if (type === "choice") {
                if ((0, _lodash.isArray)(data.choices)) {
                    return data.choices.join(", ");
                } else if ((0, _lodash.isString)(data.choices)) {
                    return data.choices;
                } else {
                    return JSON.stringify(data); // potentially malformed?
                }
            } else if (type === "selectType") {
                // unsupported (should not be encountered here.)
                return JSON.stringify(data.uid);
            } else if (type === "draw") {
                // unsupported (should not be encountered here.)
                return JSON.stringify(data);
            } else if (type === "image") {
                // unsupported (should not be encountered here.)
                return JSON.stringify(data);
            }
            console.warn("getFormattedValueForType: no strategy for formatting " + type + " is defined. Returning data as it is.");
            return JSON.stringify(data);
        }
    }, {
        key: "getInstanceSubTitleComponent",
        value: function getInstanceSubTitleComponent(datakey, instanceData, instanceDataDefinition) {
            switch (datakey) {
                case "issues":
                    var issueInstance = instanceData;
                    var description = issueInstance.description ? React.createElement("span", null, issueInstance.description, React.createElement("br", null)) : null;
                    var catName = issueInstance.category ? issueInstance.category : issueInstance.categoryName;
                    return React.createElement("span", null, description, catName);
                case "objects":
                    var objectInstance = instanceData;
                    var objectDef = instanceDataDefinition;
                    var objectInfoTitle = objectDef.additionalInfoTitle ? objectDef.additionalInfoTitle + ": " : "";
                    var objectInfo = objectInstance.additionalInfo ? objectInstance.additionalInfo : "";
                    return objectInfo ? objectInfoTitle + objectInfo : "";
                case "items":
                    var itemInstance = instanceData;
                    var itemDef = instanceDataDefinition;
                    var itemInfoTitle = itemDef.additionalInfoTitle ? itemDef.additionalInfoTitle + ": " : "";
                    var itemInfo = itemInstance.additionalInfo ? itemInstance.additionalInfo : "";
                    return itemInfo ? itemInfoTitle + itemInfo : "";
            }
        }
    }, {
        key: "isReportModificationDisallowed",
        value: function isReportModificationDisallowed() {
            var uid = (0, _selectn2.default)("appUserProfile.uid", this.props.user);
            var permission = this.props.auth.highestPermission;
            var isManager = permission !== "user";
            var isOwnReport = uid === this.props.reportDetail.selectedReport.userUid;
            var isSharedWithUser = this.props.reportDetail.selectedReport.sharedWith.indexOf(this.props.user.appUserProfile.UserId) !== -1;
            if (this.props.reportDetail.selectedReport.state === "approved") {
                return true;
            } else if (this.props.reportDetail.selectedReport.state === "open") {
                return !isOwnReport && !isSharedWithUser;
            } else if (this.props.reportDetail.selectedReport.state === "closed") {
                return true;
            }
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var isModificationDisabled = this.isReportModificationDisallowed();
            var selectedInstanceUid = this.props.instanceUid;
            // grab the instance data...
            var instanceData = (0, _lodash.find)(this.props.currentReportData.dataEntries, { uid: selectedInstanceUid });
            // console.log(instanceData);
            var subTitle = this.getInstanceSubTitleComponent(this.props.currentReportData.dataKey, instanceData, this.props.currentReportData.dataDefinition); // string or react element
            var showImageUploader = false;
            var instanceImageComponents = [];
            // description or additionInfo is available...
            if (this.props.currentReportData.dataKey === "issues") {
                // we need to explicitly cast here...
                var issueInstance = instanceData;
                var description = issueInstance.description ? React.createElement("span", null, issueInstance.description, React.createElement("br", null)) : null;
                var catName = issueInstance.category ? issueInstance.category : issueInstance.categoryName;
                showImageUploader = true;
                instanceImageComponents = (0, _lodash.map)(issueInstance.attachmentUids, function (attachmentUid) {
                    var extension = "";
                    if (attachmentUid.indexOf("PDF") !== -1) {
                        extension = ".pdf";
                    } else {
                        extension = ".png";
                    }
                    var picUrl = __API_BASE_URL__ + "/assets/attachments/reports/" + _this2.props.reportDetail.selectedReport.uid + "/" + attachmentUid;
                    return React.createElement("li", { key: attachmentUid, style: { overflowX: "hidden" } }, React.createElement("a", { href: picUrl + extension, target: "_blank" }, React.createElement("img", { width: "auto", height: "200px", src: picUrl + "THUMBNAIL.png", style: {
                            transform: "translate3d(-50%, 0, 0)",
                            marginLeft: "50%"
                        } })), React.createElement(_reactBootstrap.Button, { disabled: isModificationDisabled, bsStyle: "default", onClick: function onClick() {
                            if (isModificationDisabled === false) {
                                _this2.onImageDelete(attachmentUid);
                            }
                        } }, React.createElement("i", { className: "fa fa-times" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.deleteImage" })));
                });
            }
            var parametersComponents = [];
            // build up all potential references to other objects/items/issues through the definiton...
            var groupedCrossReferences = (0, _lodash.compact)((0, _lodash.map)(this.props.reportDetail.reportData, function (data) {
                var dataKey = data.dataKey;
                var dataDefinition = data.dataDefinition;

                if (dataDefinition.uid === _this2.props.currentReportData.dataDefinition.uid) {
                    // exclude!
                    return null;
                }
                return {
                    referencedItems: [],
                    dataKey: dataKey,
                    dataDefinition: dataDefinition
                };
            }));
            // furhermore attach all parameters to show for this very instance and all references for the tables
            (0, _lodash.each)(this.props.reportDetail.reportStepData, function (stepData) {
                (0, _lodash.each)(stepData.fields, function (field) {
                    if (field.fieldDefinition.type === "table") {
                        // console.log(field);
                        if (field.field && field.field.data) {
                            var data = field.field.data;
                            (0, _lodash.each)(data.rows, function (row) {
                                // console.log(row, selectedInstanceUid);
                                if (row.ref === selectedInstanceUid) {
                                    // these fields are parameters of this instance!
                                    // CROSS-REFERENCE: instance --> row.fields
                                    (0, _lodash.each)(row.fields, function (instanceField) {
                                        // get the fieldDefinition for the row...
                                        var rowFieldDefinition = (0, _lodash.find)(field.fieldDefinition.properties.fields, { properties: { uid: instanceField.uid } });
                                        // console.log("check CROSS-REFERENCE: instance --> row.fields", rowFieldDefinition);
                                        if (instanceField.type === "reference") {
                                            var referencedItem = (0, _lodash.reduce)(_this2.props.reportDetail.reportData, function (reducedEntry, data) {
                                                var foundEntry = (0, _lodash.find)(data.dataEntries, { uid: instanceField.data.uid });
                                                if (foundEntry) {
                                                    return {
                                                        item: foundEntry,
                                                        dataDefinition: data.dataDefinition,
                                                        dataKey: data.dataKey
                                                    };
                                                }
                                                return reducedEntry;
                                            }, null);
                                            if (!referencedItem) {
                                                // noop if not found, potential fatal error in datastructure?
                                                if (instanceField.data && instanceField.data.uid !== null) {
                                                    console.error("unable to find referencedItem for instanceField non null", instanceField);
                                                }
                                            } else {
                                                var referencedPool = (0, _lodash.find)(groupedCrossReferences, { dataDefinition: { uid: rowFieldDefinition.properties.refUid } });
                                                // <li key={instanceField.uid}>{rowFieldDefinition.properties.title} -- {stepData.stepDefinition.title} -- {field.fieldDefinition.properties.title} -- {instanceField.type} -- {instanceField.uid} -- {JSON.stringify(instanceField.data)} -- {referencedItem.title}</li>
                                                // Table Referenced Instances
                                                referencedPool.referencedItems.push(React.createElement("tr", { key: instanceField.uid }, React.createElement("td", { className: "col-xs-4" }, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/" + referencedItem.dataKey + "/" + referencedItem.dataDefinition.uid + "/" + referencedItem.item.uid }, referencedItem.item.title)), React.createElement("td", { className: "col-xs-4" }, rowFieldDefinition.properties.title), React.createElement("td", { className: "col-xs-4" }, React.createElement("small", null, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/steps/" + stepData.stepDefinition.uid }, stepData.stepDefinition.title), React.createElement("br", null), field.fieldDefinition.properties.title))));
                                            }
                                        } else {
                                            // Direct Parameters on the instance.
                                            parametersComponents.push(React.createElement("tr", { key: instanceField.uid }, React.createElement("td", { className: "col-xs-4" }, _this2.getFormattedValueForType(instanceField.type, instanceField.data)), React.createElement("td", { className: "col-xs-4" }, rowFieldDefinition.properties.title), React.createElement("td", { className: "col-xs-4" }, React.createElement("small", null, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/steps/" + stepData.stepDefinition.uid }, stepData.stepDefinition.title), React.createElement("br", null), field.fieldDefinition.properties.title))));
                                        }
                                    });
                                } else {
                                    // the row is not mapped to this instance, but there might be fields inside this OTHER instance which reference THIS instance!
                                    // CROSS-REFERENCE: row.field --> instance
                                    (0, _lodash.each)(row.fields, function (instanceField) {
                                        // we are dealing with another instance (other datadefinition, find uids in reference fields that map to ours here!)
                                        var rowFieldDefinition = (0, _lodash.find)(field.fieldDefinition.properties.fields, { properties: { uid: instanceField.uid } });
                                        // console.log("check CROSS-REFERENCE: row.field --> instance", rowFieldDefinition);
                                        if (instanceField.type === "reference" && instanceField.data.uid === selectedInstanceUid) {
                                            console.log("found matching cross-reference, ref row instance is ", instanceField, rowFieldDefinition, field, row);
                                            var crossReferencedItem = (0, _lodash.reduce)(_this2.props.reportDetail.reportData, function (reducedEntry, data) {
                                                var foundEntry = (0, _lodash.find)(data.dataEntries, { uid: row.ref });
                                                if (foundEntry) {
                                                    return {
                                                        item: foundEntry,
                                                        dataDefinition: data.dataDefinition,
                                                        dataKey: data.dataKey
                                                    };
                                                }
                                                return reducedEntry;
                                            }, null);
                                            if (!crossReferencedItem) {
                                                // noop if not found, potential fatal error in datastructure?
                                                if (instanceField.data && instanceField.data.uid !== null) {
                                                    console.error("unable to find crossReferencedItem for instanceField non null", instanceField);
                                                }
                                                return; // noop further
                                            }
                                            var referencedPool = (0, _lodash.find)(groupedCrossReferences, { dataDefinition: { uid: field.fieldDefinition.properties.refUid } });
                                            // sample for link to step (currently issues with react-scroll)
                                            // <Link to={`/reports/detail/${this.props.reportDetail.selectedReport.uid}/steps/${stepData.stepDefinition.uid}`}>{stepData.stepDefinition.title}</Link>
                                            // Table Referenced Instances (back reference)
                                            referencedPool.referencedItems.push(React.createElement("tr", { key: "cross_reference_back" + row.ref }, React.createElement("td", { className: "col-xs-4" }, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/" + crossReferencedItem.dataKey + "/" + crossReferencedItem.dataDefinition.uid + "/" + crossReferencedItem.item.uid }, crossReferencedItem.item.title)), React.createElement("td", { className: "col-xs-4" }, rowFieldDefinition.properties.title), React.createElement("td", { className: "col-xs-4" }, React.createElement("small", null, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/steps/" + stepData.stepDefinition.uid }, stepData.stepDefinition.title), React.createElement("br", null), field.fieldDefinition.properties.title))));
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            });
            // build up typeReferencees view (issues -> item/object and vice versa)
            (0, _lodash.each)(this.props.reportDetail.typeReferences, function (typeRef) {
                // first make sure the current looked upon instanceId matches ref1 or ref2 of the typeReference...
                var ref1MatchesInstanceUid = typeRef.ref1 === _this2.props.instanceUid;
                var ref2MatchesInstanceUid = typeRef.ref2 === _this2.props.instanceUid;
                var anyMatch = ref1MatchesInstanceUid || ref2MatchesInstanceUid;
                if (anyMatch === false) {
                    return; // noop
                }
                // console.log("found qualified typeReference for this instance which must be looked at", typeRef, "ref1MatchesInstanceUid:" + ref1MatchesInstanceUid, "ref2MatchesInstanceUid:" + ref2MatchesInstanceUid);
                var targetUid = ref1MatchesInstanceUid ? typeRef.ref2 : typeRef.ref1;
                var referencedItem = (0, _lodash.reduce)(_this2.props.reportDetail.reportData, function (reducedEntry, data) {
                    var foundEntry = (0, _lodash.find)(data.dataEntries, { uid: targetUid });
                    if (foundEntry) {
                        return {
                            item: foundEntry,
                            dataDefinition: data.dataDefinition,
                            dataKey: data.dataKey
                        };
                    }
                    return reducedEntry;
                }, null);
                if (!referencedItem) {
                    // noop if not found, potential fatal error in datastructure?
                    console.error("typeReferences: unable to find referencedItem for instanceField", typeRef, targetUid);
                    return; // noop, don't continue.
                }
                var referencedPool = (0, _lodash.find)(groupedCrossReferences, { dataDefinition: { uid: referencedItem.dataDefinition.uid } });
                referencedPool.referencedItems.push(React.createElement("tr", { key: "typeReferences_" + targetUid }, React.createElement("td", { className: "col-xs-4" }, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this2.props.reportDetail.selectedReport.uid + "/" + referencedItem.dataKey + "/" + referencedItem.dataDefinition.uid + "/" + targetUid }, referencedItem.item.title)), React.createElement("td", { className: "col-xs-4" }, React.createElement("small", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.typeReferences.title" }))), React.createElement("td", { className: "col-xs-4" }, _this2.getInstanceSubTitleComponent(referencedItem.dataKey, referencedItem.item, referencedItem.dataDefinition))));
            });
            return React.createElement("div", { styleName: "content" }, React.createElement(_reactRouter.Link, { className: "btn btn-link btn-lg", to: "/reports/detail/" + this.props.reportDetail.selectedReport.uid + "/" + this.props.currentReportData.dataKey + "/" + this.props.currentReportData.dataDefinition.uid }, React.createElement("i", { className: "fa fa-chevron-left", "aria-hidden": "true" }), "  ", this.props.currentReportData.dataDefinition.namePlural), React.createElement(_reactBootstrap.Grid, { fluid: true }, React.createElement("h3", { style: { marginBottom: 4 } }, instanceData.title, " ", React.createElement(_reactBootstrap.Button, { bsSize: "xsmall", disabled: isModificationDisabled, bsStyle: "default", onClick: function onClick(e) {
                    _this2.setState({ showModal: "edit", isLoading: _this2.state.isLoading });
                } }, React.createElement("i", { className: "fa fa-edit", "aria-hidden": "true" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.postfix.first.uppercase.edit" }))), React.createElement("h4", { style: { marginTop: 0 } }, React.createElement("small", null, subTitle)), function () {
                if (showImageUploader) {
                    return React.createElement("div", null, React.createElement("h3", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.images.title" }), " ", React.createElement(_reactBootstrap.Button, { disabled: isModificationDisabled, bsStyle: "primary", onClick: function onClick() {
                            _this2.setState({ showModal: "imageUpload", isLoading: _this2.state.isLoading });
                        } }, React.createElement("i", { className: "fa fa-upload" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.steps.uploadImage" }))), React.createElement(_reactBootstrap.Row, null, React.createElement("ul", { styleName: "image-gallery" }, instanceImageComponents)));
                }
                return null;
            }(), React.createElement("h3", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.fields.title" })), function () {
                if (parametersComponents.length === 0) {
                    // no parameters to show.
                    return React.createElement("small", { style: { paddingLeft: 10, color: "grey" } }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.parameters" }));
                }
                return React.createElement(_reactBootstrap.Table, { striped: true, bordered: true, condensed: true, hover: true }, React.createElement("tbody", null, parametersComponents));
            }(), function () {
                return (0, _lodash.map)(groupedCrossReferences, function (crossReference) {
                    if (crossReference.referencedItems.length === 0) {
                        // no entries are here, continue to render it with an empty message!
                        return React.createElement("div", { key: crossReference.dataDefinition.uid }, React.createElement("h3", null, crossReference.dataDefinition.namePlural), React.createElement("small", { style: { paddingLeft: 10, color: "grey" } }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.crossReferences", values: { namePlural: crossReference.dataDefinition.namePlural } })));
                    }
                    return React.createElement("div", { key: crossReference.dataDefinition.uid }, React.createElement("h3", null, crossReference.dataDefinition.namePlural), React.createElement(_reactBootstrap.Table, { striped: true, bordered: true, condensed: true, hover: true }, React.createElement("tbody", null, crossReference.referencedItems)));
                });
            }()), React.createElement(_ReportDetailUploadAttachmentModal2.default, { uid: this.props.instanceUid, showModal: this.state.showModal === "imageUpload", onClose: function onClose() {
                    return _this2.setState({ showModal: null, isLoading: _this2.state.isLoading });
                }, onSuccess: function onSuccess(uid) {
                    return _this2.onImageUploadSuccess(uid);
                } }), React.createElement(_ReportDetailAddEditTypeModal2.default, { saveReportBeforeAddType: true, mode: "edit", reportDataDefinitionUid: this.props.currentReportData.dataDefinition.uid, onClose: function onClose() {
                    return _this2.setState({ showModal: null, isLoading: _this2.state.isLoading });
                }, onSuccess: function onSuccess() {
                    return _this2.setState({ showModal: null, isLoading: _this2.state.isLoading });
                }, showModal: this.state.showModal === "edit", selectedItem: instanceData }));
        }
    }]);

    return ReportDetailTypeInstance;
}(React.Component);
ReportDetailTypeInstance = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        auth: state.auth,
        user: state.user,
        reportDetail: state.reportDetail
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailTypeInstance);
exports.default = ReportDetailTypeInstance;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTypeInstance.tsx
 ** module id = 1282
 ** module chunks = 0
 **/